





































import { defineComponent } from '@nuxtjs/composition-api'

import Link from '@/components/Link'

export default defineComponent({
  name: 'FooterLinksColumn',
  components: {
    Link,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {}
  },
})
